import { useValuations } from "@/hooks/useValuations.js";
import { Table, TableHead, TableBody, TableRow, TableHeader, TableCell } from "@/components/ui/table.js";

function fmtEur(n: number | null): string {
  if (n === null || n === undefined) return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}

export default function Valuations(): JSX.Element {
  const { data = [], isLoading } = useValuations();

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-h1 font-display text-ink">Valutazioni richieste</h1>
        <p className="text-body text-ink-soft">{data.length} richieste totali</p>
        <p className="text-meta text-ink-mute">
          Disclaimer hardcoded: <em>Valutazione indicativa basata su statistiche OMI. Non costituisce perizia.</em>
        </p>
      </header>

      <div className="overflow-x-auto rounded border border-rule bg-surface">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader className="w-[180px]">Data</TableHeader>
              <TableHeader>Input</TableHeader>
              <TableHeader className="w-[140px] text-right">Min</TableHeader>
              <TableHeader className="w-[160px] text-right">Atteso</TableHeader>
              <TableHeader className="w-[140px] text-right">Max</TableHeader>
              <TableHeader className="w-[100px] text-right">Conf.</TableHeader>
              <TableHeader className="w-[200px]">Disclaimer</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => {
              const input = (row.input ?? {}) as Record<string, unknown>;
              return (
                <TableRow key={row.id}>
                  <TableCell className="font-mono text-meta text-ink">{new Date(row.created_at).toLocaleString("it-IT")}</TableCell>
                  <TableCell className="text-body text-ink-soft">
                    {String(input.city ?? "—")} · {String(input.property_type ?? "—")} · {String(input.mq ?? "—")} mq
                  </TableCell>
                  <TableCell className="text-right font-mono text-meta text-ink">{fmtEur(row.output_low)}</TableCell>
                  <TableCell className="text-right font-mono text-body-strong text-accent">{fmtEur(row.output_expected)}</TableCell>
                  <TableCell className="text-right font-mono text-meta text-ink">{fmtEur(row.output_high)}</TableCell>
                  <TableCell className="text-right font-mono text-meta text-ink-mute">{row.confidence?.toFixed(2) ?? "—"}</TableCell>
                  <TableCell className="font-mono text-meta uppercase text-ink-mute">{row.disclaimer_id}</TableCell>
                </TableRow>
              );
            })}
            {!isLoading && data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} className="py-12 text-center text-ink-mute">Nessuna valutazione.</TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
